export default "__VITE_ASSET__CDAM7L_C__"